<script setup lang="ts">
import { ref, computed } from 'vue'
import { useNavigation } from '../useNavigation'
import type { Student2Context } from '@/types/student2'

const props = defineProps<{ context: Student2Context; url: string }>()
const { getLink: $getLink, gotoOnClick: $gotoOnClick } = useNavigation()
const currentIframeUrl = ref<string | null>(props.url?.toString() || null)
const isDemo = computed(() => props.context.smartbook?.demo)

const $updateUrl = () => {
  currentIframeUrl.value = props.url.toString()
}

defineExpose({ $updateUrl })
</script>

<template>
  <section class="student-cabinet__page student-external-page">
    <span class="student-external-page__loader">
      <v-icon class="mdi-spin blue-text" size="32">mdi-timer-sand</v-icon>
    </span>

    <div v-if="isDemo" class="student-external-page__demo-popup">
      <span class="student-external-page__demo-badge"> <v-icon>mdi-information-outline</v-icon> DEMO </span>

      <v-button mode="rounded warn filled" :href="$getLink({ tab: 'home', hash: 'shop' })" @click="$gotoOnClick">
        Купить Умный Учебник
      </v-button>
    </div>

    <iframe class="student-external-page__iframe" :src="currentIframeUrl || undefined" frameborder="0" />
  </section>
</template>

<style lang="scss">
@use '~/styles/pages/student2/screen' as s2;

.student-external-page {
  position: relative;
  overflow: hidden;

  &__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    background: white;
    padding: 8px;
    border-radius: 8px;
    box-shadow:
      0px 4px 20px 0px #00000026,
      0px 2px 4px 0px #00000033;

    z-index: -1;
  }

  &__iframe {
    width: 100%;
    height: 100%;
  }

  &__demo-popup {
    position: absolute;
    z-index: 0;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);

    transition:
      left 0.5s ease,
      top 0.3s ease;

    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__demo-badge {
    background: rgba($darkGray, 0.85);
    border-radius: 999px;
    display: flex;
    gap: 8px;
    align-items: center;
    color: white;
    padding: 8px 12px;
    font-weight: bold;
  }
}
</style>
